import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VChip,
    {
      staticClass: "my-2",
      attrs: {
        color: _vm.item.isActive ? "primary" : "bg-primary",
        "text-color": _vm.item.isActive ? "bg-gray-0" : "primary",
      },
      on: {
        click: function ($event) {
          _vm.onClick($event, () => _vm.item.onClick(_vm.item))
        },
      },
    },
    [
      _c(VIcon, { attrs: { size: "24" } }, [
        _vm._v("\n    ui-icon-sliders\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }